@if (shouldUpdateCart) {
  <cx-spinner/>
} @else {
  <div class="custom-cart">
    <section [ngClass]="isSticky === true ? 'sticky d-md-none' : 'd-none'" *ngIf="productEntries?.length > 0">
      <div class="savings-total d-flex flex-wrap justify-content-center gap-3 align-items-end mx-n3 mx-sm-n4 mt-4 mt-sm-3 p-3 box-shadow-bottom u-background--white">
        <h3 class="c-heading c-heading-h3 m-0">
          {{ 'addToCartItems.orderSubtotal' | cxTranslate }}
          <span *ngIf="!updateTotal; else noPrice">{{ standardCartDetails?.subTotal?.value | localCurrency }}</span>
          <ng-template #noPrice>
            {{ 'addToCartItems.noprice' | cxTranslate }}
          </ng-template>
        </h3>
        <div class="d-flex align-items-center">
          <button
            *ngIf="!updateTotal"
            type="button"
            class="c-button c-button--primary mt-0 mt-sm-2 proceedCheckout"
            (click)="proceedToCheckout()"
            [disabled]="orderBlock || checkoutClicked || yfEntry"
            [ngClass]="orderBlock || yfEntry ? 'disableCTA' : ''">
            <em class="fa fa-spinner fa-spin" *ngIf="checkoutClicked"></em>
            {{ 'addToCartItems.proceedToCheckout' | cxTranslate }}
          </button>
          <button
            *ngIf="updateTotal"
            class="c-button c-button--secondary mt-0 mt-sm-2 updateOrder"
            (click)="updateCart()">
            {{ 'addToCartItems.updateOrder' | cxTranslate }}
          </button>
        </div>
      </div>
    </section>

    <div *ngIf="showDisclaimer" class="global-alerts">
      <div class="alert alert-info alert-dismissable getAccAlert">
        <button
          (click)="closeDisclaimerAlert()"
          class="close closeAccAlert"
          aria-hidden="true"
          data-dismiss="alert"
          type="button"
          data-di-id="di-id-4f6d7b93-70563360">
          ×
        </button>
        <div class="text-center w-100">
          {{ 'addToCartItems.disclaimerMsgCart' | cxTranslate }}
        </div>
      </div>
    </div>
    <section class="no-print container mb-3">
      <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-right mb-2 mb-sm-0">
          <a
            id="continueShoppingId"
            data-di-id="#continueShoppingId"
            href="/BRL/Open-Catalogue/c/1"
            target=""
            class="c-link">
            <fa-icon [icon]="faChevronLeft" class="icon"></fa-icon>
            {{ 'addToCartItems.continueShopping' | cxTranslate }}
          </a>
        </div>
        <div
          *ngIf="productEntries?.length > 0"
          class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-right d-flex flex-wrap gap-1 justify-content-md-end">
          <ng-template #popSaveTitle>{{
              'addToCartItems.saveOrderTitle' | cxTranslate
            }}</ng-template>
          <ng-template #popSaveContent>
            <input
              type="text"
              class="save-order"
              required
              #name="ngModel"
              [(ngModel)]="saveCartName"
              (keypress)="omit_special_char($event)"
              maxlength="30" />
            <span *ngIf="name.errors?.required" class="common-error required">{{
                errorMsg
              }}</span>
            <span class="float-none common-error">{{ errorMsg }}</span>
            <div class="c-popover">
              <button
                type="reset"
                class="popover-close popover-cancel-button c-button c-button--secondary"
                (click)="toggle(p2)">
                {{ 'addToCartItems.cancel' | cxTranslate }}
              </button>
              <button
                type="submit"
                class="popover-cancel-button c-button c-button--primary"
                data-di-id="di-id-3064f17d-e97cc628"
                (click)="saveOrder()">
                {{ 'addToCartItems.save' | cxTranslate }}
              </button>
            </div>
          </ng-template>
          <a
            class="c-link"
            [ngbPopover]="popSaveContent"
            [popoverTitle]="popSaveTitle"
            popoverClass="popover-links saveorder-incart"
            triggers="manual"
            placement="top"
            container="body"
            #p2="ngbPopover"
            href="javascript:;"
            (click)="toggle(p2)">
            <span>{{ 'addToCartItems.saveOrder' | cxTranslate }}</span>
            <fa-icon [icon]="faRectangleList" class="icon"></fa-icon>
          </a>
          <ng-template #popTitle
          ><span> {{ 'addToCartItems.clearTitle' | cxTranslate }}</span>
          </ng-template>
          <ng-template #popContent>
            <div class="c-popover">
              <button
                type="reset"
                class="popover-close popover-cancel-button c-button c-button--secondary"
                data-di-id="di-id-d01008be-fb6e135c"
                (click)="toggle(p1)">
                {{ 'addToCartItems.cancel' | cxTranslate }}
              </button>
              <button
                type="submit"
                class="popover-cancel-button c-button c-button--primary"
                data-di-id="di-id-3064f17d-e97cc628"
                (click)="clearChildCart()">
                {{ 'addToCartItems.clearCart' | cxTranslate }}
              </button>
            </div>
          </ng-template>
          <a
            class="c-link"
            [ngbPopover]="popContent"
            [popoverTitle]="popTitle"
            popoverClass="popover-links"
            triggers="manual"
            placement="top"
            container="body"
            #p1="ngbPopover"
            href="javascript:;"
            (click)="toggle(p1)">
            <span>{{ 'addToCartItems.clearCart' | cxTranslate }}</span>
            <fa-icon [icon]="faTrashCan" class="icon"></fa-icon>
          </a>
          <a
            id="tealium-xls"
            data-di-id="#tealium-xls"
            class="c-link"
            aria-label="download as"
            href="javascript:void(0)"
            target=""
            (click)="exportXls()">
            <span>{{ 'addToCartItems.xls' | cxTranslate }}</span>
            <fa-icon [icon]="faFileExcel" class="icon"></fa-icon>
          </a>
          <a
            id="printLinkId"
            data-di-id="#printLinkId"
            class="c-link"
            href="javascript:void(0)"
            target=""
            onclick="window.print();">
            <span>{{ 'addToCartItems.print' | cxTranslate }}</span>
            <fa-icon [icon]="faPrint" class="icon"></fa-icon>
          </a>
        </div>
      </div>
    </section>
    <div *ngIf="deleteSuccess !== ''" class="global-alerts">
      <div class="c-alert-banner alert-info alert-dismissable getAccAlert">
        <button
          (click)="closeAlert()"
          class="close closeAccAlert"
          aria-hidden="true"
          data-dismiss="alert"
          type="button"
          data-di-id="di-id-4f6d7b93-70563360">
          ×
        </button>
        <span class="delete-succ" [innerHTML]="deleteSuccess"></span>&nbsp;{{
          'addToCartItems.deleteSuccessMsg' | cxTranslate
        }}
      </div>
    </div>

    <div *ngIf="addSuccess && !quickOrderRemovedEntry" class="global-alerts">
      <div class="c-alert-banner alert-info">
        {{ 'addToCartItems.addProdSuccess' | cxTranslate }}
        <button
          (click)="closeAlert()"
          class="close"
          aria-hidden="true"
          data-dismiss="alert"
          type="button">
          ×
        </button>
      </div>
    </div>

    <div *ngIf="orderBlock && showDangerAlert && productEntries?.length > 0" class="global-alerts">
      <div class="alert alert-danger">
        <button
          (click)="closeDangerAlert()"
          class="close"
          aria-hidden="true"
          data-dismiss="alert"
          type="button">
          ×
        </button>
        {{ 'addToCartItems.orderBlockMsg' | cxTranslate }}
      </div>
    </div>

    <section class="container c-prod-details mb-0 mb-sm-3" *ngIf="productEntries?.length > 0; else emptyCart">
      <div class="row checkout u-background--white" id="leftCont-rightNav-cart">
        <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 float-left u-background--white pb-4 pt-4 pt-md-4 pb-md-4" style="min-height: 357px">
          <!-- Contract -->
          <div class="row py-4 u-border-bottom-grey mb-4" *ngIf="standardCartDetails?.contractId">
            <div class="col-md-12">
              <em class="fa fa-clipboard font-n"></em>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{this.standardCartDetails?.contractId }}
              ({{ this.standardCartDetails?.contractName }})
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="col-md-12 pl-0 mb-4">
                <h3 class="mb-3 font-bold">
                <span class="px-2">
                  <em class="fa fa-map-marker-alt font-n"></em>
                </span>
                  {{ 'addToCartItems.shipTo' | cxTranslate }}
                </h3>
                <div>
                <span class="d-block pl-3 text-fixed-medium font-bold">{{selectedData?.companyName }}</span>
                </div>
                <div class="pl-3">
                  <p class="mb-2 text-fixed-medium">
                    {{ selectedData?.line1 ? selectedData?.line1 + ', ' : ''
                    }}<br *ngIf="selectedData?.line1" />
                    {{ selectedData?.line2 ? selectedData?.line2 + ', ' : ''
                    }}<br *ngIf="selectedData?.line2" />
                    {{ selectedData?.town ? selectedData?.town + ', ' : ''
                    }}<br *ngIf="selectedData?.town" />
                    {{
                      selectedData?.region?.isocodeShort
                        ? selectedData?.region?.isocodeShort + ' '
                        : ''
                    }}
                    {{ selectedData?.postalCode }}
                  </p>
                </div>
                <div class="pl-3">
                <span role="button" *ngIf="changeLocation" (click)="open(content)" class="c-link ml-1">
                  {{ 'orderConfirmation.changeLoc' | cxTranslate }}
                </span>
                </div>
                <div class="firstLevel-acc cartShipToHeader">
                  <section class="col-sm-7 col-md-7 col-lg-7 locleft">
                    <section class="ship-address">
                      <section>
                        <section class="checkout-modal">
                          <section class="modal-dialog">
                            <section class="modal-content">
                              <ng-template #content let-modal>
                                <section class="checkout-modal modal-selector">
                                  <section class="modal-dialog">
                                    <section class="modal-content">
                                      <div class="close">
                                        <em
                                          class="fa-solid fa-x c-icon-primary c-icon-primary-sm c-icon-round-hover mr-3 mt-4"
                                          (click)="
                                          modal.dismiss('Cross click')">
                                        </em>
                                      </div>
                                      <section
                                        class="modal-header cart-Modal-Header">
                                        <h2 class="c-heading-36 font-bold u-border-bottom-grey pb-4 w-100" id="modal-basic-title">
                                          {{ 'header.selectAccount' | cxTranslate }}
                                        </h2>
                                      </section>
                                      <section class="modal-body">
                                        <section class="input-group loc-SearchBar">
                                          <div class="c-text-input">
                                            <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
                                            <input
                                              type="text"
                                              #clientName
                                              (keyup)="SearchClientName(clientName.value)"
                                              class="form-control searchboxnew"
                                              placeholder="{{'account.filterByLocation' | cxTranslate}}"
                                            />
                                          </div>
                                        </section>
                                        <section>
                                          <section [ngClass]="{ displayNone: searchedClientList?.length === 0}"
                                            class="custom-radio radio_grp label-location w-100 mt-4">
                                            <table aria-describedby="shiptolocation" *ngFor="let data of searchedClientList; let i = index" class="w-100 mt-2">
                                              <th></th>
                                              <tr class="line-location" [ngClass]="{'label-location': i !== searchedClientList.length - 1}">
                                                <td class="u-border-top-grey pt-1">
                                                  <input
                                                    type="radio"
                                                    (change)="onOptionsSelected(data)"
                                                    [id]="data?.id"
                                                    [checked]="selectedData?.id == data?.id"
                                                    name="customRadio"
                                                    class="custom-control-input" />
                                                  <label
                                                    class="custom-control-label secloct w-100 text-fixed-medium font-bold"
                                                    [for]="data?.id">
                                                    {{ data?.companyName }}
                                                    {{'(' + data?.cnpjNumber + ')' }}
                                                  </label>
                                                  <p class="labelpp mb-2 text-fixed-medium">
                                                    {{ data?.line1 ? data?.line1 + ', ' : '' }}
                                                    {{ data?.line2 ? data?.line2 + ', ' : '' }}
                                                    {{ data?.town ? data?.town + ', ' : '' }}
                                                    {{ data?.region?.isocodeShort ? data?.region?.isocodeShort + ' ' : '' }}
                                                    {{ data?.postalCode }}
                                                  </p>
                                                </td>
                                              </tr>
                                            </table>
                                          </section>
                                          @if (!searchedClientList?.length) {
                                            <section class="custom-radio radio_grp label-location w-100 mt-4">
                                              <p class="u-border-top-grey pt-4 text-fixed-medium font-bold">
                                                {{ 'account.noAccountResults' | cxTranslate }}
                                              </p>
                                            </section>
                                          }
                                        </section>
                                      </section>
                                      <section
                                        class="modal-footer justify-content-start">
                                        <button
                                          type="button"
                                          class="c-button c-button--primary ml-3"
                                          (click)="onSubmit()"
                                          (click)="modal.close('Save click')">
                                          {{ 'account.done' | cxTranslate }}
                                        </button>
                                      </section>
                                    </section>
                                  </section>
                                </section>
                              </ng-template>
                            </section>
                          </section>
                        </section>
                      </section>
                    </section>
                  </section>
                </div>
              </div>
            </div>
            <div class="col-md-6" *ngIf="soldToData">
              <div class="col-md-12 pl-0 mb-4 pr-12">
                <h3 class="mb-3 font-bold">
                <span class="px-2">
                  <em class="fa fa-map-marker-alt font-n"></em>
                </span>
                  {{ 'addToCartItems.soldTo' | cxTranslate }}
                </h3>
                <div>
                <span class="d-block pl-3 text-fixed-medium font-bold">{{
                    soldToData?.companyName
                  }}</span>
                </div>
                <div class="pl-3">
                  <p class="mb-2 text-fixed-medium">
                    {{ soldToData?.line1 ? soldToData?.line1 + ', ' : '' }}
                    <br *ngIf="soldToData?.line1" />
                    {{ soldToData?.line2 ? soldToData?.line2 + ', ' : '' }}
                    <br *ngIf="soldToData?.line2" />
                    {{ soldToData?.town ? soldToData?.town + ', ' : '' }}
                    <br *ngIf="soldToData?.town" />
                    {{ soldToData?.region?.isocodeShort ? soldToData?.region?.isocodeShort + ' ' : '' }}
                    {{ soldToData?.postalCode }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- end of div -->
          <section id="pdp-list1" class="panel-collapse mr-0 mr-sm-4">
            <section class="panel-body no-location-panel">
              <div *ngFor="let productEntry of productEntries" class="pdp-list-data row">
                <div class="col-md-4 col-lg-2">
                  <a (click)="productDetails(productEntry)">
                    <img
                      class="img-fluid"
                      src="{{ productEntry.PRIMARY ? productEntry?.PRIMARY?.url : fallbackImage }}"
                      alt="" />
                  </a>

                  <div class="hidden-xs delete-popover-container no-print pt-2">
                    <ng-template #popTitleDelete>
                      {{ 'addToCartItems.deleteTitle' | cxTranslate }}
                    </ng-template>
                    <ng-template #popContentDelete>
                      <div class="c-popover">
                        <button
                          type="reset"
                          class="popover-close popover-cancel-button c-button c-button--secondary mb-2"
                          data-di-id="di-id-d01008be-fb6e135c"
                          (click)="toggle(p1)">
                          {{ 'addToCartItems.cancel' | cxTranslate }}
                        </button>
                        <button
                          class="popover-cancel-button c-button c-button--primary mb-2"
                          type="submit"
                          data-di-id="di-id-3064f17d-e97cc628"
                          (click)="deleteCart(productEntry?.entryNumber, productEntry?.product?.name)">
                          {{ 'addToCartItems.delete' | cxTranslate }}
                        </button>
                      </div>
                    </ng-template>
                    <a
                      [ngbPopover]="popContentDelete"
                      [popoverTitle]="popTitleDelete"
                      triggers="manual"
                      #p1="ngbPopover"
                      placement="top"
                      class="trash text-fixed-legal-copy color-grey-light"
                      (click)="toggle(p1)"
                      href="javascript:;">
                      <em class="fa fa-trash-o" aria-hidden="true"></em>
                      <span class="d-none d-md-inline">{{ 'addToCartItems.delete' | cxTranslate }}</span>
                    </a>
                  </div>
                </div>

                <div class="col-md-8 col-lg-5">
                  <a (click)="productDetails(productEntry)">
                    <h2 [innerHTML]="productEntry.product.name" class="c-heading c-heading-h4 mb-4"></h2>
                  </a>
                  <p [innerHTML]="productEntry.product.description" class="text-fixed-medium color-grey"></p>

                  <p class="text-fixed-legal-copy color-grey-dark mb-1">
                  <span class="font-bold">{{ 'plp.productNumber' | cxTranslate }}</span>
                    : &nbsp;{{ productEntry?.product?.sapEan }}
                  </p>
                  <p class="text-fixed-legal-copy color-grey-dark" *ngIf="productEntry?.product?.actualPotency">
                  <span class="font-bold">{{ 'plp.actualPotency' | cxTranslate }}</span>:&nbsp;

                    {{ productEntry.product.actualPotency }}
                  </p>
                </div>

                <div class="col-xs-6 col-md-6 col-lg-3 price-list">
                  <h6 class="text-fixed-legal-copy color-grey-dark font-weight-bold" *ngIf="productEntry.product.actualPotency; else notActualPotency">
                    {{ 'plp.your_price' | cxTranslate }}
                  </h6>
                  <ng-template #notActualPotency>
                    <h6 class="text-fixed-legal-copy color-grey-dark font-weight-bold">
                      {{ 'plp.yourPrice' | cxTranslate }}
                      {{ ProductUtils.getUnitTranslation(selectedChannel) }}
                    </h6>
                  </ng-template>
                  <span class="c-heading c-heading-h3">
                  {{ productEntry?.basePrice?.value | localCurrency }}
                </span>
                </div>

                <div class="col-xs-6 col-md-6 col-lg-2 unit-list px-0">
                  <div class="mb-2 text-center font-weight-bold color-grey-dark">
                    {{ 'plp.units' | cxTranslate }}
                  </div>
                  <label class="mb-2 text-center font-weight-bold color-grey-dark" for="{{ 'prodQuantity' + productEntry?.entryNumber }}">
                    {{ ProductUtils.getUnitTranslation(selectedChannel) }}
                  </label>
                  <div class="unit-area d-flex flex-nowrap align-items-center justify-content-center">
                  <span id="{{ 'unitMinus' + productEntry?.entryNumber }}" class="d-none"></span>
                    <span id="{{ 'unitMinusDisable' + productEntry?.entryNumber }}" class="d-none"></span>
                    <span id="{{ 'unitPlus' + productEntry?.entryNumber }}" class="d-none"></span>
                    <span id="{{ 'unitPlusDisable' + productEntry?.entryNumber }}" class="d-none"></span>
                    <button
                      id="{{ 'minusIcon' + productEntry?.entryNumber }}"
                      class="c-count-change-btn"
                      [ngClass]="{ disabled: productEntry?.quantity < 2 }"
                      aria-hidden="true"
                      (click)="performQuantityComputation(2, productEntry)">
                      <em class="fa fa-minus" aria-hidden="true"></em>
                    </button>
                    <input
                      [class]="{
                        'custom-cart__quantityPublic': selectedChannel === PriceChannel.PUBLIC,
                        'custom-cart__quantityPrivate': selectedChannel === PriceChannel.PRIVATE,
                        'required': isStockInsufficient(productEntry?.entryNumber)
                      }"
                      autoSizeInput
                      [includeBorders]="true"
                      type="number"
                      class="prod-quantity text-center"
                      value="{{ productEntry?.quantity }}"
                      id="{{ 'prodQuantity' + productEntry?.entryNumber }}"
                      min="1"
                      max="{{ProductUtils.getMaximumQuantity(selectedChannel)}}"
                      (blur)="performQuantityComputation(null, productEntry)" />
                    <button
                      id="{{ 'plusIcon' + productEntry?.entryNumber }}"
                      class="c-count-change-btn"
                      [ngClass]="{ disabled: productEntry?.quantity > ProductUtils.getMaximumQuantity(selectedChannel) }"
                      aria-hidden="true"
                      (click)="performQuantityComputation(1, productEntry)">
                      <em class="fa fa-plus" aria-hidden="true"></em>
                    </button>
                  </div>
                  <div *ngIf="productEntry?.conditionsForCartonsLogicMeet" class="w-100 mt-1 d-flex justify-content-center text-center" id="{{'noOfCartons' + productEntry?.entryNumber}}">
                    <span class="red" *ngIf="calculateNumberOfCartons(productEntry) <=1 else moreThanOneCarton">min 1 cx embarque</span>
                    <ng-template #moreThanOneCarton>
                      <span>{{calculateNumberOfCartons(productEntry)}} cx embarque</span>
                    </ng-template>
                  </div>
                  <div class="quantitiesInfo mt-2" *ngIf="isStockInsufficient(productEntry?.entryNumber)">
                    <p>
                      {{ getMaxQuantity(productEntry?.entryNumber) }}
                      {{ 'addToCartItems.maxAllowedQuantity' | cxTranslate }}
                    </p>
                  </div>
                  <div id="{{ 'noOfDoses' + productEntry?.entryNumber }}" class="doses-section d-none">
                    {{ productEntry?.product?.quantityPerUnit * productEntry?.quantity }}
                    {{ 'plp.doses' | cxTranslate }}
                  </div>
                </div>
              </div>
            </section>
          </section>
        </div>

        <aside class="col-md-4 col-sm-12 cart-main-page">
          <div class="aside-section savings-total" aria-label="subTotal" [ngClass]="isSticky === true ? 'd-none d-md-block' : ''">
              <h3 class="c-heading c-heading-h3">
                {{ 'addToCartItems.orderSubtotal' | cxTranslate }}
                <span *ngIf="!updateTotal; else noPrice"
                >{{ standardCartDetails?.subTotal?.value | localCurrency }}
            </span>
                <ng-template #noPrice>
                  {{ 'addToCartItems.noprice' | cxTranslate }}
                </ng-template>
              </h3>
              <button
                *ngIf="!updateTotal"
                type="button"
                class="c-button c-button--primary mt-3 proceedCheckout no-print"
                (click)="proceedToCheckout()"
                [disabled]="orderBlock || checkoutClicked || yfEntry || quantityBtnDisabled"
                [ngClass]="orderBlock || yfEntry ? 'disableCTA' : ''">
                <em class="fa fa-spinner fa-spin" *ngIf="checkoutClicked"></em>
                {{ 'addToCartItems.proceedToCheckout' | cxTranslate }}
              </button>
              <button
                *ngIf="updateTotal"
                class="c-button c-button--secondary mt-3 updateOrder"
                (click)="updateCart()">
                {{ 'addToCartItems.updateOrder' | cxTranslate }}
              </button>
              <p class="font-bold mt-4">{{ 'addToCartItems.priceRecalculate' | cxTranslate }}</p>

            <div class="d-flex align-items-center" *ngIf="isAsmEnabled && selectedChannel === PriceChannel.PRIVATE">
              <label class="custom-checkbox justify-content-start">
                <input
                  type="checkbox"
                  class="input-check middle-row"
                  (change)="checkBoxSlobClicked($event)"
                  [class.checked]="slobStatus" />
                <span class="checkmark"></span>
                <span class="label-text">{{ 'addToCartItems.slob' | cxTranslate }}</span>
              </label>
            </div>
          </div>
          <div class="c-widget c-quick-order-widget" aria-label="quickOrderSection">
            <div>
              <h3 class="c-widget-title c-heading c-heading-h3">{{ 'addToCartItems.addProducts' | cxTranslate }}</h3>
              <h6 class="c-heading c-heading-h5 color-secondary">{{ 'addToCartItems.quickOrder' | cxTranslate }}
              </h6>
              <p class="text-fixed-legal-copy">{{ 'addToCartItems.searchItems' | cxTranslate }}</p>
            </div>
            <app-quick-order class="w-100"></app-quick-order>
          </div>
        </aside>
      </div>
    </section>

    <ng-template #emptyCart>
      <app-empty-cart compName="EmptyCartParagraphComponent"></app-empty-cart>
    </ng-template>
  </div>
}
